import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import NumberFormat from 'react-number-format';
import SuccessPaymentEnhancedTableHead from './SuccessPaymentEnhancedTableHead';
import SuccessPaymentInvoiceToolBar from './SuccessPaymentInvoiceToolBar';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        padding:theme.spacing.unit
    },
    table: {
        minWidth: 1020,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    tableCell: {
        /*padding: '4px 16px'*/
    },
    paymentDetails: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        padding: theme.spacing.unit
    },
    rightAlign: {
        textAlign: 'right'
    },
});


class SuccessPaymentEnhancedTable extends Component{

    constructor(props) {
        super(props);
        this.state = {
            selected: [],
            data: this.props.data,
            selectedCurrencyInvoices: 0
        };
    }


    totalPaymentAmount = () => {
           let invoiceTotalPayableAmount = this.state.data.invoiceDetails.filter(invoice => invoice.entryNo).reduce((accumulator, invoice) => {
           `${invoice.paymentAmount}`.replace(/[.]/g,",");
            let invoiceAmt = parseFloat(invoice.paymentAmount); 
            return accumulator + (+invoice.paymentAmount)
        },  0);
       return  invoiceTotalPayableAmount
    }    
    render() {
        const { data, selected} = this.state;
        const { classes } = this.props;
        let customerDetails = JSON.parse(localStorage.getItem('customer'));
         return (
            <div>
                <Paper className={classes.root}>
                    <div className={classes.tableWrapper}>
                    <SuccessPaymentInvoiceToolBar/>
                        <Table className={classes.table} aria-labelledby="tableTitle">                    
                        <SuccessPaymentEnhancedTableHead
                        numSelected={selected.length}                       
                       />
                       <TableBody>
                                {data['invoiceDetails'].map(n => {                            
                                    return (
                                        <TableRow key={n.entryNo}>
                                            <TableCell component="th" scope="row">
                                                {n.invoiceNumber}
                                            </TableCell>
                                            <TableCell component="th" scope="row" style={{paddingLeft: '35px'}}>
                                                {n.installments}
                                            </TableCell>
                                            <TableCell className={classes.tableCell}>{n.invoiceDate}</TableCell>
                                            <TableCell numeric className={classes.tableCell}>
                                            <Typography>
                                            <NumberFormat value={n.paymentAmount} 
                            fixedDecimalScale = {true} decimalScale={2}
                            displayType={'text'} thousandSeparator={true} prefix={(customerDetails.currencyCode === 'CAD')?'CAD ':'$ '}/>
                                            </Typography>
                                        </TableCell>
                                        </TableRow>
                                    );
                                })}                                
                            </TableBody>                      
        </Table>        
        </div>
        <Grid container spacing={24} justify="flex-end">
                        <Grid item>
                            <Typography variant="subheading" align="center">
                            <NumberFormat value={this.totalPaymentAmount()}
                            fixedDecimalScale = {true} decimalScale={2}
                            displayType={'text'} thousandSeparator={true} prefix={(customerDetails.currencyCode === 'CAD')?'Total Invoice Amount: CAD ':'Total Invoice Amount: $'}/>                                                                                
                            </Typography>
                        </Grid>                        
                    </Grid>
        </Paper>
        </div>
       
        )


    }

}


SuccessPaymentEnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired,
    data: PropTypes.object,
};
export default withStyles(styles)(SuccessPaymentEnhancedTable);


// WEBPACK FOOTER //
// ./src/SuccessPaymentEnhancedTable.js